/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


// ST - CUSTOM JS 

function slideToggle(button, element, duration = 500) {
  const elementHeight = element.scrollHeight;
  const svg = button.querySelector('svg');

  if (!element.style.transition) {
    element.style.transition = `height ${duration}ms ease`;
    element.style.overflow = 'hidden';
    element.style.height = `${elementHeight}px`;
    svg.classList.add('open');
  } else {
    element.style.height = '0px';
    element.style.removeProperty("transition");
    svg.classList.remove('open');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const toggleButtons = document.querySelectorAll('.accordion-button');
  toggleButtons.forEach(button => {
    button.addEventListener('click', (event) => {
      const content = event.currentTarget.nextElementSibling;
        slideToggle(button, content, 500);
    });
  });
});

// INFINITE OPTIONS APP

"Shoppad.apps.infiniteoptions".split(".").reduce(function(o, x) { if (!o[x]) {o[x] ={};} return o[x] }, window);

window.Shoppad.apps.infiniteoptions.beforeReady = function(subscribe) {
  subscribe('fieldChange', function(event) {
    setTimeout(() => {
      const priceElIO = document.querySelector(".infiniteoptions-price");
      const priceIO = priceElIO.querySelector(".price-item--regular").textContent.trim();
      
      document.querySelector(".price-list .ST-price").innerHTML = priceIO;
    }, 800);
  });
};